<template>
  <div id="bottom_right_area">
    <transition name="el-zoom-in-bottom">
      <div
        v-if="shouldDisplayBottomRightArea"
        ref="bottomRightArea"
        class="bottom-right-area"
        :class="{ collapsed: isCollapsed, isCountDown: logoutRemainTime.show }"
        :style="{ height }"
      >
        <div
          v-if="logoutRemainTime.show"
          id="validation_expired"
          class="count-down-container"
        >
          <div class="title">
            距離系統自動登出
          </div>
          <div ref="logoutMainArea" class="content">
            <span class="remain">剩餘</span>
            <span class="timer">
              <span v-if="logoutRemainTime.day > 0" class="day">{{ logoutRemainTime.day }}天</span>
              <span
                class="hr"
                :class="{ passed: logoutRemainTime.hr == '00' }"
              >{{ logoutRemainTime.hr }}</span>
              <span class="dot">:</span>
              <span
                class="min"
                :class="{
                  passed:
                    logoutRemainTime.hr == '00' && logoutRemainTime.min == '00',
                }"
              >{{ logoutRemainTime.min }}</span>
              <span class="dot">:</span>
              <span
                class="sec"
                :class="{
                  passed:
                    logoutRemainTime.hr == '00' &&
                    logoutRemainTime.min == '00' &&
                    logoutRemainTime.sec == '00',
                }"
              >{{ logoutRemainTime.sec }}</span>
            </span>
          </div>
          <div class="subtitle" @click="whyLogoutDialog = true">
            為什麼要自動登出？
          </div>
        </div>
        <div
          v-else-if="true"
          class="bottom-right-news-container"
        >
          <div ref="newsMainArea" class="title news" v-html="bottomRightNews.titleHtml"></div>
          <div class="subtitle" @click="clickBottomRightLink()">
            {{ bottomRightNews.contentText }}
          </div>
        </div>
        <div
          class="collapseBtn"
          @click="isCollapsed = !isCollapsed"
        >
          <i
            v-if="isCollapsed"
            class="icon-m-back"
            aria-hidden="true"
          />
          <i v-else class="icon-m-next" aria-hidden="true" />
        </div>
      </div>
    </transition>
    <el-dialog
      :visible.sync="whyLogoutDialog"
      title="為什麼要自動登出？"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      center
    >
      <p>智生活為了確保貴社區的資料安全，因此必須定時將帳號登出</p>
      <p class="warning">
        提醒您在自動登出前，建議完成/儲存您當前的操作，以避免資料遺失。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" round @click="whyLogoutDialog = false">我瞭解了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import { apiMvc } from '@/api/mvc.js'
import { googleFormTransform } from '@/js/utils'

export default {
  data () {
    return {
      whyLogoutDialog: false,
      isCollapsed: false,
      expiredTime: null,
      clickLogout: false,
      bottomRightNews: {
        titleHtml: '',
        contentText: '',
        contentLink: ''
      },
      fullHeight: null,
      mainAreaHight: null
    }
  },
  computed: {
    logoutRemainTime () {
      const timestart = Math.floor(new Date().getTime() / 1000)
      const timeout = Math.floor(new Date(this.expiredTime).getTime() / 1000)
      const duetime = timeout - timestart
      const show = duetime < 60 * 60 && duetime > 0
      const day = Math.floor(duetime / 3600 / 24)
      let hr = Math.floor(duetime / 3600) % 24
      let min = Math.floor(duetime / 60) % 60
      let sec = duetime % 60
      hr = hr < 10 ? '0' + hr : hr
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      const timeObj = {
        day,
        hr,
        min,
        sec,
        show,
        duetime
      }
      return timeObj
    },
    hasNews () {
      // 有右下角提示窗之資料
      return this.bottomRightNews.titleHtml || this.bottomRightNews.contentText
    },
    shouldDisplayBottomRightArea () {
      // 要顯示自動登出提示或是 CMS 配置右下角提示之區塊
      return this.hasNews || this.logoutRemainTime.show
    },
    height () {
      if (this.fullHeight && this.mainAreaHight) {
        const mainAreaPadding = 10
        const collapsedHeight = this.mainAreaHight + mainAreaPadding
        const result = (this.isCollapsed ? collapsedHeight : this.fullHeight) + 'px'
        return result
      }
      return 'unset'
    }
  },
  watch: {
    logoutRemainTime (val) {
      if (val.duetime <= 0 && !this.clickLogout) {
        this.clickLogout = true
        this.$alert('請重新登入系統', '', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          this.$logoutCommunity()
        })
      }
    },
    'logoutRemainTime.show' () {
      // 切換顯示模式時需要重新計算高度
      this.updateHeight()
    }
  },
  mounted () {
    this.getNews()
    this.dueCountDown()
  },
  methods: {
    async getNews () {
      // 取得右下角提示窗之資料
      try {
        const res = await apiMvc.getBottomRightNews()
        const item = res.data.Data.find(item => {
          if (item.s_type === 2 && item.is_check === 1) {
            const startDate = new Date(item.s_start)
            const dueDate = new Date(item.s_due)
            const currentDate = new Date()
            // 將日期部分保留，時間部分歸零
            startDate.setHours(0, 0, 0, 0)
            dueDate.setHours(23, 59, 59, 999)
            return currentDate >= startDate && currentDate <= dueDate
          }
          return false
        })
        const { s_title: titleHtml, s_tips: contentText, s_link: contentLink } = item || {}
        this.bottomRightNews = {
          titleHtml,
          contentText,
          contentLink
        }
        this.updateHeight()
      } catch (error) {
        console.error(error)
      }
    },
    clickBottomRightLink () {
      this.$sendGAEvent('右下角提示窗點擊數', {
        value: `click_${this.bottomRightNews.titleHtml}_${this.bottomRightNews.contentText}_${this.bottomRightNews.contentLink}`
      })
      // google 表單需要嘗試帶入已知資料
      const processedUrl = googleFormTransform.fetchURL(this.bottomRightNews.contentLink)
      window.open(processedUrl)
    },
    dueCountDown () {
      if (localStorage.getItem('loginUserInfo')) {
        const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
        this.expiredTime = new Date(loginUserInfo.ExpireTime)
      }
      setTimeout(() => {
        this.dueCountDown()
      }, 1000)
    },
    updateHeight () {
      // 不 hard code 高度、使動態產生的高度也能使用動畫進行和緩的視覺過渡 (#89731)
      this.fullHeight = null
      this.mainAreaHight = null
      this.$nextTick(() => {
        this.fullHeight = this.$refs.bottomRightArea?.offsetHeight || null
        this.mainAreaHight = this.$refs.newsMainArea?.offsetHeight || this.$refs.logoutMainArea?.offsetHeight || null
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#bottom_right_area
  ::v-deep .el-dialog
    +basicDialog
    p
      font-size: map-get($fontSize,large)
      margin-bottom: 10px
      color: #5f5f5f
      &.warning
        color: #d15b21
  .bottom-right-area
    position: fixed
    right: 0
    bottom: 0
    color: #5f5f5f
    font-weight: bold
    background-color: #fff
    line-height: 40px
    width: 400px
    border-top-left-radius: 15px
    padding: 25px 10px 5px 25px
    box-shadow: 0px 0px 30px 5px $bgDark1
    box-sizing: border-box
    z-index: 98
    transition: all 0.5s ease-in-out
    &.collapsed
      padding: 10px 0 0 15px
      .title,.subtitle
        display: none
      .title.news
        display: block
    .collapseBtn
      width: 25px
      height: 25px
      position: absolute
      right: 0
      top: 0
      background-color: #383838
      cursor: pointer
      i
        display: block
        color: #fff
        font-size: 13px
        position: absolute
        top: 25%
        left: 25%
        transform: translate(-50%,-50%)
        transform: rotate(90deg)
    .title
      color: #5f5f5f
      font-size: 19px
      line-height: 1
      padding: 10px 0
    .subtitle
      color: #999999
      font-size: 16px
      font-weight: normal
      text-decoration: underline
      cursor: pointer
      line-height: 1
      margin-top: 10px
      margin-bottom: 15px
      &:hover
        opacity: 0.8
    .content
      display: flex
      gap: 20px
      color: $warnColor
      font-size: 35px
      .remain
        font-size: 19px
        vertical-align: 2px
      .timer
        display: flex
        gap: 10px
        .day
          font-size: 16px
        .passed
          color: #5f5f5f
      .dot
        color: #5f5f5f
        padding: 0 2px
</style>
